import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { BACKEND_URL, API } from '../utils/api';

const Footer = () => {
  const navigate = useNavigate();
  const [books, setBooks] = useState([]);

  useEffect(() => {
    fetch(`${API}/books`).then(r => r.json()).then(bks => {
      if (bks?.length) setBooks(bks.map(b => ({ ...b, slug: b.slug })));
    }).catch(() => {});
  }, []);

  return (
    <footer className="border-t border-black/[0.04] py-8 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="flex flex-col sm:flex-row justify-between gap-6 mb-6">
          <div>
            <p className="text-sm font-semibold mb-2">Museo de la Fe</p>
            <p className="text-xs text-muted-foreground/60 max-w-[250px]">Libritos cristianos ilustrados para niños de 3 a 10 años basados en historias bíblicas.</p>
          </div>
          <div>
            <p className="text-xs font-medium mb-2">Libritos</p>
            <div className="flex flex-col gap-1">
              {books.slice(0, 4).map(b => (
                <button key={b.slug} onClick={() => navigate(`/libro/${b.slug}`)} className="text-xs text-muted-foreground/50 hover:text-foreground text-left transition-colors">{b.title}</button>
              ))}
              {books.length > 4 && (
                <button onClick={() => navigate('/')} className="text-xs text-muted-foreground/30 hover:text-foreground text-left transition-colors">Ver todos →</button>
              )}
            </div>
          </div>
          <div>
            <p className="text-xs font-medium mb-2">Enlaces</p>
            <div className="flex flex-col gap-1">
              <button onClick={() => navigate('/')} className="text-xs text-muted-foreground/50 hover:text-foreground text-left transition-colors">Tienda</button>
              <button onClick={() => navigate('/preguntas-frecuentes')} className="text-xs text-muted-foreground/50 hover:text-foreground text-left transition-colors">FAQ</button>
              <a href="mailto:admin@museodelafe.com" className="text-xs text-muted-foreground/50 hover:text-foreground transition-colors">Contacto</a>
              <button onClick={() => navigate('/privacidad')} className="text-xs text-muted-foreground/50 hover:text-foreground text-left transition-colors">Privacidad</button>
              <button onClick={() => navigate('/terminos')} className="text-xs text-muted-foreground/50 hover:text-foreground text-left transition-colors">Términos</button>
            </div>
          </div>
        </div>
        <div className="border-t border-border/50 pt-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-[10px] text-muted-foreground/40">© {new Date().getFullYear()} Museo de la Fe. Todos los derechos reservados.</p>
          <p className="text-[10px] text-muted-foreground/30">{books.length} libros · Historias bíblicas para niños</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
